module.exports = __webpack_public_path__ + "static/media/iconMoon.2afc1c11.svg";